/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeRoleBodyExpectedVersionExclusiveMin = 0;
export const changeRoleBodyExpectedVersionMax = 9007199254740991;

export const ChangeRoleBody = zod.object({
  role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
  expectedVersion: zod
    .int()
    .gt(changeRoleBodyExpectedVersionExclusiveMin)
    .max(changeRoleBodyExpectedVersionMax),
});

export type ChangeRoleBody = zod.input<typeof ChangeRoleBody>;
export type ChangeRoleBodyOutput = zod.output<typeof ChangeRoleBody>;
